// extracted by mini-css-extract-plugin
module.exports = {"target":"hand_detection_target__26cqe","webcam":"hand_detection_webcam__3wDtE","canvas":"hand_detection_canvas__3MZwy"};